export default "__VITE_ASSET__IjXgF5h2__"